// Mirrors Wheels.ERP.Shared.Inventory.

export interface ItemStockDto {
  itemStockId: string;
  branchId: string;
  itemId: string;
  itemNameAr: string;
  itemNameEn: string | null;
  itemSku: string;
  onHand: number;
  reserved: number;
  updatedAt: string;
}

export const STOCK_MOVEMENT_TYPE = {
  OPENING_COUNT: 1,
  RECOUNT: 2,
  WASTAGE: 3,
  SALE: 4,
  SALE_VOID: 5,
  GRN: 6,
  TRANSFER: 7,
  MANUAL_ADJUST: 99,
} as const;

export type StockMovementType =
  (typeof STOCK_MOVEMENT_TYPE)[keyof typeof STOCK_MOVEMENT_TYPE];

export interface StockMovementDto {
  stockMovementId: string;
  branchId: string;
  itemId: string;
  type: StockMovementType;
  quantityDelta: number;
  onHandBefore: number;
  onHandAfter: number;
  note: string | null;
  relatedOrderId: string | null;
  recordedAt: string;
  batchNumber: string | null;
  /** ISO date "YYYY-MM-DD" (server sends DateOnly). */
  expiryDate: string | null;
}

export interface AdjustStockRequest {
  branchId: string;
  itemId: string;
  type: StockMovementType;
  quantityDelta: number;
  note: string | null;
  batchNumber?: string | null;
  /** "YYYY-MM-DD" — DateOnly on the server. */
  expiryDate?: string | null;
}

/** Phase 4F-1/4F-2 expiring report row. */
export interface ExpiringBatchDto {
  stockMovementId: string;
  branchId: string;
  itemId: string;
  itemNameAr: string;
  itemNameEn: string | null;
  itemSku: string;
  batchNumber: string | null;
  expiryDate: string;
  daysUntilExpiry: number;
  originalQuantity: number;
  receivedAt: string;
  /** 4F-2: how much of this batch is still on the shelf. */
  remainingQuantity: number;
}

// ---- Stock transfers (Phase 2C) ----

export interface StockTransferLineDto {
  stockTransferLineId: string;
  itemId: string;
  itemNameAr: string;
  itemNameEn: string | null;
  itemSku: string;
  quantity: number;
}

export interface StockTransferDto {
  stockTransferId: string;
  fromBranchId: string;
  fromBranchNameAr: string;
  toBranchId: string;
  toBranchNameAr: string;
  sequenceNumber: number;
  displayNumber: string;
  transferredAt: string;
  notes: string | null;
  lines: StockTransferLineDto[];
}

export interface CreateStockTransferLineRequest {
  itemId: string;
  quantity: number;
}

export interface CreateStockTransferRequest {
  fromBranchId: string;
  toBranchId: string;
  notes?: string | null;
  lines: CreateStockTransferLineRequest[];
}
